/**
 * helpConstants — paramètres figés du Help Drawer (HELP-DRAWER, annexe).
 *
 * Centralisés ici pour rester ajustables sans fouiller les composants.
 */

/** Longueur min. de saisie avant que l'entrée IA devienne déclenchable. */
export const AI_MIN_CHARS = 3

/** Nb max de résultats affichés en recherche. */
export const MAX_SEARCH_RESULTS = 8

/** Bonus de score accordé aux articles « sur cette page » en recherche globale. */
export const CONTEXT_BONUS = 8

/** Paliers de densité (état Contextuel, champ vide) — cf. §6.2. */
export const COMPACT_LIST_MIN = 6 // 6–9 → liste compacte
export const GROUPING_THRESHOLD = 10 // ≥10 → sections repliables par catégorie

/** Un groupe de catégorie doit contenir au moins ce nombre d'articles. */
export const MIN_GROUP_SIZE = 2

/** Nb d'entrées « recherches » récentes conservées. */
export const MAX_RECENT_SEARCHES = 5

/** Nb de conversations IA récentes conservées (volumineuses → plafond bas, lot §5). */
export const MAX_RECENT_CONVERSATIONS = 5
